// ========== Toast Notifications ==========
window.showToast = function (message, type) {
  type = type || 'success';
  var container = document.getElementById('ToastContainer');
  if (!container) return;
  var toast = document.createElement('div');
  toast.className = 'toast toast--' + type;
  toast.textContent = message;
  container.appendChild(toast);
  // Trigger animation
  requestAnimationFrame(function () {
    toast.classList.add('toast--visible');
  });
  setTimeout(function () {
    toast.classList.remove('toast--visible');
    toast.addEventListener('transitionend', function () {
      toast.remove();
    });
  }, 3000);
};

// Global JS for basic theme functionality
document.addEventListener('DOMContentLoaded', () => {
  console.log('Mega Pizza theme loaded.');
  adjustFixedLayout();
  window.addEventListener('resize', adjustFixedLayout);

  // Show/hide sticky cart button based on cart count
  updateStickyCartBtn();

  // Panneau commande (page Commander) : toggle livraison/emporter + zones
  initHeroOrderPanel();
});

// Dynamically adjust layout: header below announcement bar, sticky category nav below header.
// La nav catégories est DANS le flux (sticky) : le body ne compense que announcement + header.
function adjustFixedLayout() {
  const announcement = document.querySelector('.announcement-bar');
  const header = document.querySelector('.header');
  const categories = document.querySelector('.restaurant-categories');
  if (!header) return;

  const announcementHeight = announcement ? announcement.offsetHeight : 0;
  const headerHeight = header.offsetHeight;

  // Push header below announcement bar
  header.style.top = announcementHeight + 'px';

  // Le sticky de la nav se cale sous la pile fixe (announcement + header)
  if (categories) {
    categories.style.top = (announcementHeight + headerHeight) + 'px';
  }

  document.body.style.paddingTop = (announcementHeight + headerHeight) + 'px';
}

// Hauteur totale de la pile collante (announcement + header + nav catégories)
function stickyStackHeight() {
  const announcement = document.querySelector('.announcement-bar');
  const header = document.querySelector('.header');
  const categories = document.querySelector('.restaurant-categories');
  return (announcement ? announcement.offsetHeight : 0)
    + (header ? header.offsetHeight : 0)
    + (categories ? categories.offsetHeight : 0);
}

// Sidebar Menu Logic
window.openSidebar = function () {
  const sidebar = document.getElementById('SidebarMenu');
  const overlay = document.getElementById('SidebarOverlay');

  if (sidebar && overlay) {
    sidebar.classList.add('sidebar--open');
    overlay.classList.add('sidebar-overlay--visible');
    document.body.style.overflow = 'hidden'; // Prevent background scrolling
  }
};

window.closeSidebar = function () {
  const sidebar = document.getElementById('SidebarMenu');
  const overlay = document.getElementById('SidebarOverlay');

  if (sidebar && overlay) {
    sidebar.classList.remove('sidebar--open');
    overlay.classList.remove('sidebar-overlay--visible');
    document.body.style.overflow = ''; // Restore background scrolling
  }
};

// ========== Cart Drawer Logic ==========

window.openCartDrawer = function () {
  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;
  drawer.classList.add('cart-drawer--open');
  drawer.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  updateMinOrderBar();
};

window.closeCartDrawer = function () {
  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;
  drawer.classList.remove('cart-drawer--open');
  drawer.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
};

// ========== Minimum Order Bar ==========
let _deliveryZones = [];

function loadDeliveryZones() {
  var el = document.getElementById('DeliveryZonesData');
  if (el) {
    try { _deliveryZones = JSON.parse(el.textContent); } catch (e) { _deliveryZones = []; }
  }
  // Convert minimum to cents
  _deliveryZones.forEach(function (z) {
    z.minCents = (parseFloat(z.minimum) || 0) * 100;
  });
}

function getSelectedZone() {
  var idx = localStorage.getItem('mega_delivery_zone');
  if (idx !== null && _deliveryZones[parseInt(idx, 10)]) {
    return { index: parseInt(idx, 10), zone: _deliveryZones[parseInt(idx, 10)] };
  }
  return null;
}

window.selectDeliveryZone = function (idx) {
  if (idx === '' || idx === undefined) return;
  localStorage.setItem('mega_delivery_zone', idx);
  closeZoneModal();
  updateMinOrderBar();
};

window.openZoneModal = function () {
  if (_deliveryZones.length === 0) loadDeliveryZones();
  var modal = document.getElementById('ZonePickerModal');
  var list = document.getElementById('ZonePickerList');
  if (!modal || !list) return;

  var html = '';
  _deliveryZones.forEach(function (z, i) {
    html += '<button class="zone-picker__zone zone-picker__zone--' + z.color + '" onclick="selectDeliveryZone(' + i + ')">';
    html += '<div class="zone-picker__zone-info">';
    html += '<span class="zone-picker__zone-name">' + z.name + '</span>';
    html += '<span class="zone-picker__zone-min">Min. ' + z.minimum + '.–</span>';
    html += '</div>';
    if (z.cities) {
      html += '<p class="zone-picker__zone-cities">' + z.cities + '</p>';
    }
    html += '</button>';
  });
  list.innerHTML = html;
  modal.style.display = '';
  modal.setAttribute('aria-hidden', 'false');
};

window.closeZoneModal = function () {
  var modal = document.getElementById('ZonePickerModal');
  if (modal) {
    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');
  }
};

window.updateMinOrderBar = function () {
  var bar = document.getElementById('CartMinOrderBar');
  if (!bar) return;
  // En mode "À emporter", pas de minimum de livraison
  if ((localStorage.getItem('mega_order_mode') || 'delivery') === 'pickup') {
    bar.style.display = 'none';
    return;
  }
  if (_deliveryZones.length === 0) loadDeliveryZones();
  if (_deliveryZones.length === 0) { bar.style.display = 'none'; return; }

  var selected = getSelectedZone();

  // If no zone selected, show compact link to open zone picker
  if (!selected) {
    var html = '<div class="cart-min-order__select-row" onclick="openZoneModal()">';
    html += '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>';
    html += '<span>Choisir votre zone de livraison</span>';
    html += '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;opacity:0.5;"><path d="m9 18 6-6-6-6"/></svg>';
    html += '</div>';
    bar.innerHTML = html;
    bar.style.display = '';
    return;
  }

  // Compute cart total from DOM
  var totalEl = document.getElementById('CartDrawerTotal');
  var cartTotal = totalEl ? parsePriceText(totalEl.textContent) : 0;
  var min = selected.zone.minCents;

  if (min <= 0) { bar.style.display = 'none'; return; }

  var pct = Math.min(100, Math.round((cartTotal / min) * 100));
  var remaining = min - cartTotal;

  var html = '<div class="cart-min-order__header">';
  html += '<span class="cart-min-order__text">';
  if (remaining > 0) {
    html += 'Encore ' + formatMoney(remaining) + ' pour la livraison';
  } else {
    html += '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-2px;margin-right:3px;"><path d="M20 6 9 17l-5-5"/></svg>Minimum atteint !';
  }
  html += '</span>';
  html += '<button class="cart-min-order__change" onclick="localStorage.removeItem(\'mega_delivery_zone\');updateMinOrderBar()">Changer</button>';
  html += '</div>';
  html += '<div class="cart-min-order__bar"><div class="cart-min-order__fill cart-min-order__fill--' + (remaining > 0 ? 'pending' : 'ok') + '" style="width:' + pct + '%"></div></div>';

  bar.innerHTML = html;
  bar.style.display = '';
};

// ========== Panneau commande (hero page Commander) ==========

// Écrit le mode (Livraison / À emporter) comme attribut du panier
function writeOrderModeAttr(mode) {
  var label = mode === 'pickup' ? 'À emporter' : 'Livraison';
  return fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: { 'Mode': label } })
  }).catch(function () {});
}

function applyOrderMode(mode) {
  document.querySelectorAll('[data-order-mode]').forEach(function (btn) {
    var on = btn.getAttribute('data-order-mode') === mode;
    btn.classList.toggle('is-active', on);
    btn.setAttribute('aria-selected', on ? 'true' : 'false');
  });
  document.querySelectorAll('[data-order-panel]').forEach(function (panel) {
    if (panel.getAttribute('data-order-panel') === mode) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', '');
    }
  });
  updateMinOrderBar();
}

window.setOrderMode = function (mode) {
  if (mode !== 'pickup') mode = 'delivery';
  localStorage.setItem('mega_order_mode', mode);
  applyOrderMode(mode);
  writeOrderModeAttr(mode);
};

// Rend la ligne « résultat » (commune · zone · minimum) sous le sélecteur/adresse
function renderHeroZoneResult(idx, communeLabel) {
  var result = document.getElementById('HeroZoneResult');
  if (!result) return;
  var zone = _deliveryZones[idx];
  if (!zone) return;
  while (result.firstChild) result.removeChild(result.firstChild);
  var cEl = document.createElement('strong');
  cEl.textContent = communeLabel || '';
  result.appendChild(cEl);
  result.appendChild(document.createTextNode(' · ' + zone.name + ' — Minimum de commande '));
  var mEl = document.createElement('strong');
  mEl.textContent = 'CHF ' + zone.minimum + '.–';
  result.appendChild(mEl);
  result.className = 'rhero-zone__result rhero-zone__result--' + zone.color;
  result.removeAttribute('hidden');
}

// Message « hors zone de livraison »
function renderHeroZoneOutOfArea(communeLabel) {
  var result = document.getElementById('HeroZoneResult');
  if (!result) return;
  while (result.firstChild) result.removeChild(result.firstChild);
  var cEl = document.createElement('strong');
  cEl.textContent = communeLabel || 'Cette adresse';
  result.appendChild(cEl);
  result.appendChild(document.createTextNode(' n’est pas dans nos zones de livraison. Contactez-nous pour vérifier.'));
  result.className = 'rhero-zone__result rhero-zone__result--red';
  result.removeAttribute('hidden');
}

// Sélection d'une commune dans le hero (sélecteur de repli) -> fixe la zone et son minimum
window.selectHeroCommune = function (idxStr) {
  var result = document.getElementById('HeroZoneResult');
  var sel = document.getElementById('HeroZoneSelect');
  if (idxStr === '' || idxStr === null || idxStr === undefined) {
    if (result) { result.setAttribute('hidden', ''); result.textContent = ''; }
    localStorage.removeItem('mega_delivery_zone');
    updateMinOrderBar();
    return;
  }
  var idx = parseInt(idxStr, 10);
  if (_deliveryZones.length === 0) loadDeliveryZones();
  var zone = _deliveryZones[idx];
  if (!zone) return;
  localStorage.setItem('mega_delivery_zone', String(idx));
  var commune = (sel && sel.options[sel.selectedIndex]) ? sel.options[sel.selectedIndex].textContent : '';
  renderHeroZoneResult(idx, commune);
  updateMinOrderBar();
};

// ========== Détection de zone par adresse (API suisse geo.admin.ch, gratuite) ==========

// Normalise une commune : minuscules, sans accents ni ponctuation
function normalizeCommune(s) {
  return (s || '')
    .toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
}

// Trouve l'index de zone couvrant une localité (match exact puis partiel)
function findZoneIndexForCommune(locality) {
  var target = normalizeCommune(locality);
  if (!target) return -1;
  if (_deliveryZones.length === 0) loadDeliveryZones();
  // 1) Correspondance exacte
  for (var i = 0; i < _deliveryZones.length; i++) {
    var cities = (_deliveryZones[i].cities || '').split(',');
    for (var c = 0; c < cities.length; c++) {
      if (normalizeCommune(cities[c]) === target) return i;
    }
  }
  // 2) Correspondance partielle (une commune contient l'autre)
  for (var i2 = 0; i2 < _deliveryZones.length; i2++) {
    var cities2 = (_deliveryZones[i2].cities || '').split(',');
    for (var c2 = 0; c2 < cities2.length; c2++) {
      var cn = normalizeCommune(cities2[c2]);
      if (cn && (cn.indexOf(target) !== -1 || target.indexOf(cn) !== -1)) return i2;
    }
  }
  return -1;
}

// Extrait la localité (après le NPA à 4 chiffres) d'un libellé d'adresse geo.admin.ch
function extractLocalityFromLabel(rawLabel) {
  var text = (rawLabel || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  var m = text.match(/\b(\d{4})\b\s+(.+)$/);
  if (m && m[2]) return m[2].trim();
  return text;
}

var _heroAddrTimer = null;
var _heroAddrSeq = 0;

// Applique une adresse choisie : détecte la zone et met à jour l'UI
function applyHeroAddress(rawLabel) {
  var locality = extractLocalityFromLabel(rawLabel);
  var idx = findZoneIndexForCommune(locality);
  if (idx < 0) {
    localStorage.removeItem('mega_delivery_zone');
    renderHeroZoneOutOfArea(locality);
    updateMinOrderBar();
    return;
  }
  localStorage.setItem('mega_delivery_zone', String(idx));
  var sel = document.getElementById('HeroZoneSelect');
  if (sel) sel.value = String(idx); // garde le repli synchronisé
  renderHeroZoneResult(idx, locality);
  updateMinOrderBar();
}

// Construit la liste de suggestions d'adresses
function renderHeroAddressSuggestions(results) {
  var list = document.getElementById('HeroAddressSuggest');
  var input = document.getElementById('HeroAddressInput');
  if (!list) return;
  while (list.firstChild) list.removeChild(list.firstChild);
  if (!results || results.length === 0) {
    list.setAttribute('hidden', '');
    if (input) input.setAttribute('aria-expanded', 'false');
    return;
  }
  results.forEach(function (r) {
    var attrs = r.attrs || {};
    var label = extractLocalityFromLabel(attrs.label);
    var full = (attrs.label || '').replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
    var li = document.createElement('li');
    li.className = 'rhero-zone__suggest-item';
    li.setAttribute('role', 'option');
    li.textContent = full;
    li.onclick = function () {
      if (input) input.value = full;
      renderHeroAddressSuggestions([]); // ferme la liste
      applyHeroAddress(attrs.label);
    };
    list.appendChild(li);
  });
  list.removeAttribute('hidden');
  if (input) input.setAttribute('aria-expanded', 'true');
}

// Interroge l'API geo.admin.ch (adresses suisses, gratuit, sans clé)
window.heroAddressInput = function (value) {
  var q = (value || '').trim();
  if (_heroAddrTimer) clearTimeout(_heroAddrTimer);
  if (q.length < 3) { renderHeroAddressSuggestions([]); return; }
  _heroAddrTimer = setTimeout(function () {
    var seq = ++_heroAddrSeq;
    var url = 'https://api3.geo.admin.ch/rest/services/api/SearchServer'
      + '?type=locations&origins=address&limit=8&sr=2056&searchText='
      + encodeURIComponent(q);
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (seq !== _heroAddrSeq) return; // réponse périmée
        renderHeroAddressSuggestions(data.results || []);
      })
      .catch(function () { renderHeroAddressSuggestions([]); });
  }, 250);
};

function initHeroAddressSearch() {
  var input = document.getElementById('HeroAddressInput');
  if (!input) return;
  input.addEventListener('input', function () { window.heroAddressInput(input.value); });
  // Ferme la liste au clic extérieur
  document.addEventListener('click', function (e) {
    var wrap = input.closest('.rhero-zone');
    if (wrap && !wrap.contains(e.target)) renderHeroAddressSuggestions([]);
  });
}

function buildZonesList(list) {
  while (list.firstChild) list.removeChild(list.firstChild);
  _deliveryZones.forEach(function (z) {
    var item = document.createElement('div');
    item.className = 'rhero-zones__item rhero-zones__item--' + z.color;

    var head = document.createElement('div');
    head.className = 'rhero-zones__item-head';
    var name = document.createElement('span');
    name.className = 'rhero-zones__item-name';
    name.textContent = z.name;
    var min = document.createElement('span');
    min.className = 'rhero-zones__item-min';
    min.textContent = 'Min. CHF ' + z.minimum + '.–';
    head.appendChild(name);
    head.appendChild(min);
    item.appendChild(head);

    if (z.cities) {
      var cities = document.createElement('p');
      cities.className = 'rhero-zones__item-cities';
      cities.textContent = z.cities;
      item.appendChild(cities);
    }
    list.appendChild(item);
  });
}

function initHeroOrderPanel() {
  var sel = document.getElementById('HeroZoneSelect');
  var list = document.getElementById('HeroZonesList');
  var toggle = document.querySelector('[data-order-mode]');
  if (!sel && !list && !toggle) return; // pas sur la page Commander

  if (_deliveryZones.length === 0) loadDeliveryZones();

  // Construit le sélecteur de commune (un groupe par zone)
  if (sel) {
    _deliveryZones.forEach(function (z, i) {
      if (!z.cities) return;
      var og = document.createElement('optgroup');
      og.label = z.name + ' — min. CHF ' + z.minimum + '.–';
      z.cities.split(',').forEach(function (c) {
        var city = c.trim();
        if (!city) return;
        var opt = document.createElement('option');
        opt.value = String(i);
        opt.textContent = city;
        og.appendChild(opt);
      });
      sel.appendChild(og);
    });
  }

  // Construit la liste complète des zones
  if (list) buildZonesList(list);

  // Recherche d'adresse (geo.admin.ch)
  initHeroAddressSearch();

  // Restaure la commune / zone déjà choisie
  var saved = getSelectedZone();
  if (saved && sel) {
    sel.value = String(saved.index);
    window.selectHeroCommune(String(saved.index));
  }

  // Restaure le mode de commande
  var savedMode = localStorage.getItem('mega_order_mode');
  applyOrderMode(savedMode === 'pickup' ? 'pickup' : 'delivery');
  if (savedMode) writeOrderModeAttr(savedMode);
}

// ========== Supplements Data ==========
let _supplementsData = [];

function loadSupplementsData() {
  const el = document.getElementById('SupplementsData');
  if (el) {
    try { _supplementsData = JSON.parse(el.textContent); } catch (e) { _supplementsData = []; }
  }
}

function hasSupplements() {
  if (_supplementsData.length === 0) loadSupplementsData();
  return _supplementsData.length > 0;
}

// ========== Per-product Supplement Rules ==========
let _productSupplementRules = null;

function loadProductSupplementRules() {
  if (_productSupplementRules !== null) return;
  var el = document.getElementById('ProductSupplementRules');
  if (el) {
    try { _productSupplementRules = JSON.parse(el.textContent); } catch (e) { _productSupplementRules = {}; }
  } else {
    _productSupplementRules = {};
  }
}

function getProductSupplementRule(handle) {
  loadProductSupplementRules();
  return _productSupplementRules[handle] || null;
}

// ========== Groupes d'options gratuits (sauce, épaisseur, œuf...) ==========
let _productOptionGroups = null;

function loadProductOptionGroups() {
  if (_productOptionGroups !== null) return;
  var el = document.getElementById('ProductOptionGroups');
  if (el) {
    try { _productOptionGroups = JSON.parse(el.textContent); } catch (e) { _productOptionGroups = {}; }
  } else {
    _productOptionGroups = {};
  }
}

function getProductOptionGroups(handle) {
  loadProductOptionGroups();
  return _productOptionGroups[handle] || null;
}

// Add to cart via AJAX (used by upsell section — no supplements)
window.addToCart = function (variantId, event) {
  if (event) event.stopPropagation();

  // Visual feedback on the card
  const card = event ? event.currentTarget : null;
  if (card) {
    card.classList.add('restaurant-product-card--added');
    setTimeout(() => card.classList.remove('restaurant-product-card--added'), 500);
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(response => {
      if (!response.ok) throw new Error('Erreur ajout panier');
      return response.json();
    })
    .then(() => {
      refreshCartDrawer();
      openCartDrawer();
    })
    .catch(err => {
      console.error('Add to cart error:', err);
      showToast('Erreur lors de l\'ajout au panier.', 'error');
    });
};

// Scroll upsell suggestions carousel (desktop arrows)
window.scrollUpsell = function (direction) {
  var scroll = document.querySelector('.cart-upsell__scroll');
  if (scroll) scroll.scrollBy({ left: direction * 120, behavior: 'smooth' });
};

// Add to cart from a product card — products with options open the panel
window.addToCartFromCard = function (cardEl, event) {
  if (event) event.stopPropagation();

  // Produit avec options (variantes ou suppléments) : tout passe par le panel
  if (cardEl.getAttribute('data-panel') === '1') {
    openProductPanel(cardEl.getAttribute('data-handle'), cardEl.getAttribute('data-collection'), cardEl);
    return;
  }

  const variantId = cardEl.getAttribute('data-selected-variant');
  if (!variantId) return;

  // Produit simple : ajout direct
  cardEl.classList.add('restaurant-product-card--added');
  setTimeout(() => cardEl.classList.remove('restaurant-product-card--added'), 500);

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
  })
    .then(response => {
      if (!response.ok) throw new Error('Erreur ajout panier');
      return response.json();
    })
    .then(() => {
      refreshCartDrawer();
      openCartDrawer();
    })
    .catch(err => {
      console.error('Add to cart error:', err);
      showToast('Erreur lors de l\'ajout au panier.', 'error');
    });
};

// Update cart item quantity (group-aware: syncs supplements with parent pizza)
window.updateCartItem = function (line, quantity) {
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var item = cart.items[line - 1];
      var groupId = item && item.properties && item.properties['_group_id'];

      if (!groupId) {
        // Simple item — no group
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: quantity })
        }).then(function (r) { return r.json(); });
      }

      // Find all items in this group
      var groupLines = [];
      cart.items.forEach(function (cartItem, index) {
        if (cartItem.properties && cartItem.properties['_group_id'] === groupId) {
          groupLines.push(index + 1); // 1-indexed
        }
      });

      // Sort descending for removal (to avoid index shifting)
      if (quantity === 0) {
        groupLines.sort(function (a, b) { return b - a; });
      }

      // Sequential updates for all group members
      return sequentialCartUpdates(groupLines.map(function (l) { return [l, quantity]; }), 0);
    })
    .then(function () {
      refreshCartDrawer();
    })
    .catch(function (err) {
      console.error('Update cart error:', err);
    });
};

function sequentialCartUpdates(updates, index) {
  if (index >= updates.length) return Promise.resolve();
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: updates[index][0], quantity: updates[index][1] })
  })
    .then(function (r) { return r.json(); })
    .then(function () { return sequentialCartUpdates(updates, index + 1); });
}

// Show/hide sticky cart button
function updateStickyCartBtn() {
  var btn = document.getElementById('StickyCartBtn');
  var count = document.getElementById('CartCount');
  if (!btn) return;
  var itemCount = count ? parseInt(count.textContent, 10) : 0;
  btn.style.display = itemCount > 0 ? 'flex' : 'none';
}

// Refresh cart drawer content via section rendering
function refreshCartDrawer() {
  fetch('/?sections=header')
    .then(res => res.json())
    .then(data => {
      const html = data['header'];
      if (!html) return;

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Update cart items
      const newItems = doc.getElementById('CartDrawerItems');
      const currentItems = document.getElementById('CartDrawerItems');
      if (newItems && currentItems) {
        currentItems.innerHTML = newItems.innerHTML;
      }

      // Update cart footer
      const newFooter = doc.getElementById('CartDrawerFooter');
      const currentFooter = document.getElementById('CartDrawerFooter');
      if (newFooter && currentFooter) {
        currentFooter.innerHTML = newFooter.innerHTML;
        currentFooter.style.display = newFooter.style.display;
      }

      // Update cart count badge
      const newCount = doc.getElementById('CartCount');
      const currentCount = document.getElementById('CartCount');
      if (newCount && currentCount) {
        currentCount.textContent = newCount.textContent;
      }

      // Update sticky cart button from cart.js
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var stickyTotal = document.getElementById('StickyCartTotal');
          var stickyCount = document.getElementById('StickyCartCount');
          if (stickyTotal) stickyTotal.textContent = formatMoney(cart.total_price);
          if (stickyCount) stickyCount.textContent = cart.item_count;
          updateStickyCartBtn();
          updateMinOrderBar();
        });
    })
    .catch(err => {
      console.error('Refresh cart error:', err);
    });
}

// ========== Product Panel (« Options du produit ») ==========
let _panelProduct = null;      // payload /products/{handle}.js
let _panelVariant = null;      // variante sélectionnée
let _panelSupplements = null;  // { title, list } | null
let _panelOptionGroups = null; // [{title,type,max,choices[]}] | null
let _panelBusy = false;        // anti double-clic sur l'ajout
let _panelReqSeq = 0;          // anti course de fetch (ouvrir A puis vite B)
let _panelTrigger = null;      // élément déclencheur, pour restaurer le focus

function formatMoneyCHF(cents) {
  return 'CHF ' + (cents / 100).toFixed(2);
}

window.openProductPanel = function (handle, collectionHandle, triggerEl) {
  var panel = document.getElementById('ProductPanel');
  if (!panel) return;

  _panelProduct = null;
  _panelVariant = null;
  _panelSupplements = null;
  _panelOptionGroups = null;
  _panelBusy = false;
  _panelTrigger = triggerEl || null;

  // Reset UI
  document.getElementById('ProductPanelImage').textContent = '';
  document.getElementById('ProductPanelTitle').textContent = '';
  document.getElementById('ProductPanelBasePrice').textContent = '';
  var descEl = document.getElementById('ProductPanelDesc');
  descEl.textContent = '';
  var loading = document.createElement('div');
  loading.className = 'product-panel__loading';
  loading.textContent = 'Chargement...';
  descEl.appendChild(loading);
  document.getElementById('ProductPanelSizeSection').setAttribute('hidden', '');
  document.getElementById('ProductPanelOptionGroupsSection').setAttribute('hidden', '');
  document.getElementById('ProductPanelSuppSection').setAttribute('hidden', '');
  document.getElementById('ProductPanelNoteSection').setAttribute('hidden', '');
  document.getElementById('ProductPanelSizes').textContent = '';
  document.getElementById('ProductPanelOptionGroups').textContent = '';
  document.getElementById('ProductPanelSupps').textContent = '';
  var promoFlag = document.getElementById('ProductPanelPromoFlag');
  if (promoFlag) promoFlag.hidden = true;
  var wasPrice = document.getElementById('ProductPanelWasPrice');
  if (wasPrice) { wasPrice.hidden = true; wasPrice.textContent = ''; }
  var noteInput = document.getElementById('ProductPanelNote');
  if (noteInput) noteInput.value = '';
  var addBtn = document.getElementById('ProductPanelAddBtn');
  addBtn.disabled = true;
  document.getElementById('ProductPanelTotal').textContent = '';
  var scroller = document.getElementById('ProductPanelScroll');
  if (scroller) scroller.scrollTop = 0;

  panel.classList.add('product-panel--open');
  panel.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  var closeBtn = panel.querySelector('.product-panel__close');
  if (closeBtn) closeBtn.focus();

  var seq = ++_panelReqSeq;
  fetch('/products/' + handle + '.js')
    .then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    })
    .then(function (product) {
      if (seq !== _panelReqSeq) return; // réponse périmée
      _panelProduct = product;
      renderPanelProduct(product, collectionHandle);
    })
    .catch(function (err) {
      if (seq !== _panelReqSeq) return;
      console.error('Product fetch error:', err);
      renderPanelError(handle, collectionHandle);
    });
};

function renderPanelError(handle, collectionHandle) {
  var descEl = document.getElementById('ProductPanelDesc');
  descEl.textContent = '';
  var wrap = document.createElement('div');
  wrap.className = 'product-panel__error';
  var msg = document.createElement('p');
  msg.textContent = 'Impossible de charger le produit. Vérifiez votre connexion.';
  wrap.appendChild(msg);
  var retry = document.createElement('button');
  retry.type = 'button';
  retry.className = 'product-panel__retry';
  retry.textContent = 'Réessayer';
  retry.onclick = function () { openProductPanel(handle, collectionHandle, _panelTrigger); };
  wrap.appendChild(retry);
  descEl.appendChild(wrap);
}

// Résout la source de suppléments : règle produit > pizza (tag ou collection) > rien
function resolvePanelSupplements(product, collectionHandle) {
  var rule = getProductSupplementRule(product.handle);
  if (rule && rule.supplements && rule.supplements.length > 0) {
    return { title: rule.title || 'Personnalisez votre produit', list: rule.supplements };
  }
  var tags = product.tags || [];
  var isPizza = collectionHandle === 'pizzas';
  for (var i = 0; i < tags.length; i++) {
    if (String(tags[i]).toLowerCase() === 'pizza') { isPizza = true; break; }
  }
  if (isPizza && hasSupplements()) {
    return { title: 'Composez votre pizza', list: _supplementsData };
  }
  return null;
}

// Variante d'un supplément correspondant à la taille choisie ("36 cm" ≈ "36cm")
function matchSuppVariant(supp, variantTitle) {
  var matched = supp.variants[0];
  var sizeName = (variantTitle || '').toLowerCase().replace(/\s/g, '');
  if (sizeName && supp.variants.length > 1) {
    for (var v = 0; v < supp.variants.length; v++) {
      if (supp.variants[v].title.toLowerCase().replace(/\s/g, '') === sizeName) {
        matched = supp.variants[v];
        break;
      }
    }
  }
  return matched;
}

function renderPanelProduct(product, collectionHandle) {
  // Image
  var imgWrap = document.getElementById('ProductPanelImage');
  imgWrap.textContent = '';
  var img = document.createElement('img');
  img.alt = product.title;
  img.src = product.featured_image
    ? product.featured_image.replace(/\.([a-z]+)(\?|$)/i, '_300x.$1$2')
    : 'https://placehold.co/300x300/f5f5f5/999?text=Photo';
  imgWrap.appendChild(img);

  document.getElementById('ProductPanelTitle').textContent = product.title;

  // Description : HTML Shopify (contenu marchand)
  document.getElementById('ProductPanelDesc').innerHTML = product.description || '';

  // Variante par défaut = la première (la moins chère chez Shopify si triées, sinon peu importe)
  _panelVariant = product.variants[0];
  var minPrice = product.variants.reduce(function (min, v) { return Math.min(min, v.price); }, product.variants[0].price);

  // Section tailles
  var sizeSection = document.getElementById('ProductPanelSizeSection');
  var sizesEl = document.getElementById('ProductPanelSizes');
  sizesEl.textContent = '';
  if (product.variants.length > 1) {
    product.variants.forEach(function (v, i) {
      var row = document.createElement('label');
      row.className = 'product-panel__option' + (i === 0 ? ' is-checked' : '');

      var input = document.createElement('input');
      input.type = 'radio';
      input.name = 'panel-size';
      input.checked = i === 0;
      input.setAttribute('data-variant-index', String(i));
      input.onchange = function () { selectPanelSize(input); };
      row.appendChild(input);

      var name = document.createElement('span');
      name.className = 'product-panel__option-name';
      name.textContent = v.title;
      row.appendChild(name);

      var price = document.createElement('span');
      price.className = 'product-panel__option-price';
      var delta = v.price - minPrice;
      price.textContent = delta > 0 ? '+' + formatMoneyCHF(delta) : '';
      row.appendChild(price);

      var check = document.createElement('span');
      check.className = 'product-panel__option-check';
      check.setAttribute('aria-hidden', 'true');
      check.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
      row.appendChild(check);

      sizesEl.appendChild(row);
    });
    sizeSection.removeAttribute('hidden');
  } else {
    sizeSection.setAttribute('hidden', '');
  }

  // Section suppléments
  _panelSupplements = resolvePanelSupplements(product, collectionHandle);
  var suppSection = document.getElementById('ProductPanelSuppSection');
  var suppsEl = document.getElementById('ProductPanelSupps');
  suppsEl.textContent = '';
  if (_panelSupplements) {
    document.getElementById('ProductPanelSuppTitle').textContent = _panelSupplements.title;

    var categories = { viande: [], legume: [], fromage: [], autre: [] };
    var categoryLabels = { viande: 'Viandes', legume: 'Légumes', fromage: 'Fromages', autre: 'Autres' };

    _panelSupplements.list.forEach(function (supp, srcIndex) {
      var placed = false;
      var tags = Array.isArray(supp.tags) ? supp.tags : [];
      for (var i = 0; i < tags.length; i++) {
        var tag = String(tags[i]).toLowerCase();
        if (categories[tag] !== undefined) {
          categories[tag].push({ supp: supp, srcIndex: srcIndex });
          placed = true;
          break;
        }
      }
      if (!placed) categories.autre.push({ supp: supp, srcIndex: srcIndex });
    });

    Object.keys(categories).forEach(function (cat) {
      var items = categories[cat];
      if (items.length === 0) return;

      var heading = document.createElement('h5');
      heading.className = 'product-panel__category';
      heading.textContent = categoryLabels[cat];
      suppsEl.appendChild(heading);

      items.forEach(function (entry) {
        var supp = entry.supp;
        var mv = matchSuppVariant(supp, _panelVariant.title);

        var row = document.createElement('label');
        row.className = 'product-panel__option product-panel__option--supp';

        var input = document.createElement('input');
        input.type = 'checkbox';
        input.className = 'product-panel__check';
        input.setAttribute('data-supp-index', String(entry.srcIndex));
        input.setAttribute('data-supp-id', String(mv.id));
        input.setAttribute('data-supp-price', String(mv.price));
        input.setAttribute('data-supp-title', supp.title);
        input.onchange = function () { togglePanelSupp(input); };
        row.appendChild(input);

        var name = document.createElement('span');
        name.className = 'product-panel__option-name';
        name.textContent = supp.title;
        row.appendChild(name);

        var price = document.createElement('span');
        price.className = 'product-panel__option-price';
        price.textContent = '+' + formatMoneyCHF(mv.price);
        row.appendChild(price);

        var check = document.createElement('span');
        check.className = 'product-panel__option-check';
        check.setAttribute('aria-hidden', 'true');
        check.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
        row.appendChild(check);

        suppsEl.appendChild(row);
      });
    });

    suppSection.removeAttribute('hidden');
  } else {
    suppSection.setAttribute('hidden', '');
  }

  // Section groupes d'options (choix gratuits : sauce, épaisseur, œuf...)
  renderPanelOptionGroups(product);

  // Note visible pour tous les produits
  document.getElementById('ProductPanelNoteSection').removeAttribute('hidden');

  updatePanelBasePrice();
  updatePanelTotal();
  updatePanelAddState();
}

// Icône « coché » (SVG construit en DOM, sans innerHTML)
function makePanelCheckIcon() {
  var check = document.createElement('span');
  check.className = 'product-panel__option-check';
  check.setAttribute('aria-hidden', 'true');
  var NS = 'http://www.w3.org/2000/svg';
  var svg = document.createElementNS(NS, 'svg');
  svg.setAttribute('width', '18');
  svg.setAttribute('height', '18');
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('fill', 'none');
  svg.setAttribute('stroke', 'currentColor');
  svg.setAttribute('stroke-width', '3');
  svg.setAttribute('stroke-linecap', 'round');
  svg.setAttribute('stroke-linejoin', 'round');
  var path = document.createElementNS(NS, 'path');
  path.setAttribute('d', 'M20 6 9 17l-5-5');
  svg.appendChild(path);
  check.appendChild(svg);
  return check;
}

// Rendu des groupes d'options gratuits. Radios (choix unique obligatoire) ou
// cases limitées à `max` (choix multiple). Choix enregistrés en propriété de ligne.
function renderPanelOptionGroups(product) {
  _panelOptionGroups = getProductOptionGroups(product.handle);
  var section = document.getElementById('ProductPanelOptionGroupsSection');
  var wrap = document.getElementById('ProductPanelOptionGroups');
  wrap.textContent = '';

  if (!_panelOptionGroups || _panelOptionGroups.length === 0) {
    section.setAttribute('hidden', '');
    return;
  }

  _panelOptionGroups.forEach(function (group, gIdx) {
    var isSingle = group.type !== 'multi_optional';
    var maxSel = isSingle ? 1 : (parseInt(group.max, 10) || 1);

    var title = document.createElement('h4');
    title.className = 'product-panel__section-title';
    title.textContent = group.title;
    if (isSingle) {
      var req = document.createElement('span');
      req.className = 'product-panel__req';
      req.textContent = ' *';
      title.appendChild(req);
    }
    wrap.appendChild(title);

    if (!isSingle) {
      var hint = document.createElement('p');
      hint.className = 'product-panel__section-hint';
      hint.textContent = maxSel > 1 ? ('Jusqu’à ' + maxSel + ' au choix — offert') : 'Optionnel';
      wrap.appendChild(hint);
    }

    var groupWrap = document.createElement('div');
    groupWrap.className = 'product-panel__options';
    groupWrap.setAttribute('data-og-title', group.title);
    groupWrap.setAttribute('data-og-type', isSingle ? 'single' : 'multi');
    groupWrap.setAttribute('data-og-max', String(maxSel));

    (group.choices || []).forEach(function (choice) {
      var row = document.createElement('label');
      row.className = 'product-panel__option';

      var input = document.createElement('input');
      input.type = isSingle ? 'radio' : 'checkbox';
      input.name = 'panel-og-' + gIdx;
      input.className = 'product-panel__og-input';
      input.setAttribute('data-og-choice', choice);
      input.onchange = function () { onPanelOptionChange(input); };
      row.appendChild(input);

      var name = document.createElement('span');
      name.className = 'product-panel__option-name';
      name.textContent = choice;
      row.appendChild(name);

      row.appendChild(makePanelCheckIcon());
      groupWrap.appendChild(row);
    });

    wrap.appendChild(groupWrap);
  });

  section.removeAttribute('hidden');
}

// Changement d'un choix : état visuel + plafond des choix multiples + revalidation
window.onPanelOptionChange = function (inputEl) {
  var groupWrap = inputEl.closest('.product-panel__options');
  if (groupWrap) {
    if (groupWrap.getAttribute('data-og-type') === 'single') {
      groupWrap.querySelectorAll('.product-panel__option').forEach(function (row) {
        var r = row.querySelector('input');
        row.classList.toggle('is-checked', !!(r && r.checked));
      });
    } else {
      var max = parseInt(groupWrap.getAttribute('data-og-max'), 10) || 1;
      var checks = groupWrap.querySelectorAll('.product-panel__og-input');
      var checkedCount = 0;
      checks.forEach(function (c) { if (c.checked) checkedCount++; });
      checks.forEach(function (c) {
        c.disabled = (!c.checked && checkedCount >= max);
        c.parentElement.classList.toggle('is-checked', c.checked);
        c.parentElement.classList.toggle('is-disabled', c.disabled);
      });
    }
  }
  updatePanelAddState();
};

// Tous les groupes « choix unique obligatoire » ont-ils une sélection ?
function panelRequiredOptionsMet() {
  var groups = document.querySelectorAll('#ProductPanelOptionGroups .product-panel__options');
  for (var i = 0; i < groups.length; i++) {
    if (groups[i].getAttribute('data-og-type') === 'single'
        && !groups[i].querySelector('.product-panel__og-input:checked')) {
      return false;
    }
  }
  return true;
}

// Active/désactive le bouton Ajouter selon les choix obligatoires
function updatePanelAddState() {
  var btn = document.getElementById('ProductPanelAddBtn');
  if (!btn) return;
  btn.disabled = _panelBusy || !_panelVariant || !panelRequiredOptionsMet();
}

// Collecte les choix d'options sélectionnés → { "Titre du groupe": "Choix, Choix" }
function collectPanelOptionProps() {
  var props = {};
  document.querySelectorAll('#ProductPanelOptionGroups .product-panel__options').forEach(function (g) {
    var title = g.getAttribute('data-og-title') || 'Choix';
    var vals = [];
    g.querySelectorAll('.product-panel__og-input:checked').forEach(function (c) {
      vals.push(c.getAttribute('data-og-choice'));
    });
    if (vals.length > 0) props[title] = vals.join(', ');
  });
  return props;
}

function updatePanelBasePrice() {
  if (!_panelVariant) return;
  document.getElementById('ProductPanelBasePrice').textContent = formatMoneyCHF(_panelVariant.price);

  // Promotion : prix barré + mention « EN PROMOTION » si compare_at_price plus élevé
  var flag = document.getElementById('ProductPanelPromoFlag');
  var was = document.getElementById('ProductPanelWasPrice');
  var onSale = _panelVariant.compare_at_price && _panelVariant.compare_at_price > _panelVariant.price;
  if (flag) flag.hidden = !onSale;
  if (was) {
    if (onSale) {
      was.textContent = formatMoneyCHF(_panelVariant.compare_at_price);
      was.hidden = false;
    } else {
      was.textContent = '';
      was.hidden = true;
    }
  }
}

window.selectPanelSize = function (inputEl) {
  if (!_panelProduct) return;
  var idx = parseInt(inputEl.getAttribute('data-variant-index'), 10);
  var variant = _panelProduct.variants[idx];
  if (!variant) return;
  _panelVariant = variant;

  // État visuel des lignes radio
  document.querySelectorAll('#ProductPanelSizes .product-panel__option').forEach(function (row) {
    var radio = row.querySelector('input');
    row.classList.toggle('is-checked', !!(radio && radio.checked));
  });

  updatePanelBasePrice();
  updatePanelSuppPrices();
  updatePanelTotal();
};

// Ré-apparie chaque supplément à la nouvelle taille, EN PLACE (état coché préservé)
function updatePanelSuppPrices() {
  if (!_panelSupplements || !_panelVariant) return;
  document.querySelectorAll('#ProductPanelSupps .product-panel__check').forEach(function (cb) {
    var supp = _panelSupplements.list[parseInt(cb.getAttribute('data-supp-index'), 10)];
    if (!supp) return;
    var mv = matchSuppVariant(supp, _panelVariant.title);
    cb.setAttribute('data-supp-id', String(mv.id));
    cb.setAttribute('data-supp-price', String(mv.price));
    var priceEl = cb.parentElement.querySelector('.product-panel__option-price');
    if (priceEl) priceEl.textContent = '+' + formatMoneyCHF(mv.price);
  });
}

window.togglePanelSupp = function (cbEl) {
  cbEl.parentElement.classList.toggle('is-checked', cbEl.checked);
  updatePanelTotal();
};

window.updatePanelTotal = function () {
  if (!_panelVariant) return;
  var total = _panelVariant.price;
  document.querySelectorAll('#ProductPanelSupps .product-panel__check:checked').forEach(function (cb) {
    total += parseInt(cb.getAttribute('data-supp-price'), 10) || 0;
  });
  document.getElementById('ProductPanelTotal').textContent = formatMoneyCHF(total);
};

window.addFromPanel = function () {
  if (_panelBusy || !_panelVariant || !_panelProduct) return;
  if (!panelRequiredOptionsMet()) { showToast('Veuillez compléter les choix obligatoires.', 'error'); return; }
  _panelBusy = true;
  var btn = document.getElementById('ProductPanelAddBtn');
  btn.disabled = true;

  var noteInput = document.getElementById('ProductPanelNote');
  var itemNote = noteInput ? noteInput.value.trim() : '';
  var checked = document.querySelectorAll('#ProductPanelSupps .product-panel__check:checked');
  var optProps = collectPanelOptionProps(); // { "Épaisseur": "Fine", ... }

  var body;
  if (checked.length > 0) {
    // Ajout groupé — format IDENTIQUE à l'ancien addWithSupplements
    // (consommé par cart-drawer, updateCartItem, buildCleanedCart)
    var groupId = 'grp_' + Date.now() + '_' + Math.random().toString(36).substr(2, 5);
    var parentProps = { '_group_id': groupId, '_group_type': 'parent' };
    if (itemNote) parentProps['note'] = itemNote;
    Object.keys(optProps).forEach(function (k) { parentProps[k] = optProps[k]; });
    var items = [{ id: _panelVariant.id, quantity: 1, properties: parentProps }];
    checked.forEach(function (cb) {
      items.push({
        id: parseInt(cb.getAttribute('data-supp-id'), 10),
        quantity: 1,
        properties: {
          '_group_id': groupId,
          '_group_type': 'supplement',
          'pour': _panelProduct.title
        }
      });
    });
    body = { items: items };
  } else {
    var simpleProps = {};
    if (itemNote) simpleProps['note'] = itemNote;
    Object.keys(optProps).forEach(function (k) { simpleProps[k] = optProps[k]; });
    body = { id: _panelVariant.id, quantity: 1 };
    if (Object.keys(simpleProps).length > 0) body.properties = simpleProps;
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  })
    .then(function (r) {
      if (!r.ok) throw new Error('Erreur ajout panier');
      return r.json();
    })
    .then(function () {
      closeProductPanel(); // restaure body.overflow AVANT que le drawer le reprenne
      refreshCartDrawer();
      openCartDrawer();
      showToast('Ajouté au panier !');
    })
    .catch(function (err) {
      console.error('Add from panel error:', err);
      _panelBusy = false;
      btn.disabled = false;
      showToast('Erreur lors de l\'ajout au panier.', 'error');
    });
};

window.closeProductPanel = function () {
  var panel = document.getElementById('ProductPanel');
  if (!panel) return;
  _panelReqSeq++; // annule tout fetch en cours
  panel.classList.remove('product-panel--open');
  panel.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
  if (_panelTrigger && typeof _panelTrigger.focus === 'function') {
    try { _panelTrigger.focus(); } catch (e) { /* élément disparu */ }
  }
  _panelTrigger = null;
};

// Alias transitoire : d'anciens onclick en cache peuvent encore appeler openProductModal
window.openProductModal = function (handle, collectionHandle) {
  openProductPanel(handle, collectionHandle, null);
};

// Escape ferme le panneau produit, sinon le panier
document.addEventListener('keydown', function (e) {
  if (e.key !== 'Escape') return;
  var panel = document.getElementById('ProductPanel');
  if (panel && panel.classList.contains('product-panel--open')) {
    closeProductPanel();
    return;
  }
  var drawer = document.getElementById('CartDrawer');
  if (drawer && drawer.classList.contains('cart-drawer--open')) {
    closeCartDrawer();
  }
});

// Format Shopify price (in cents) to display format
function formatMoney(cents) {
  return (cents / 100).toFixed(2) + ' CHF';
}

// Parse display price text (e.g., "22.00 CHF") back to cents (2200)
function parsePriceText(text) {
  var match = text.match(/(\d+[.,]\d+|\d+)/);
  if (!match) return 0;
  return Math.round(parseFloat(match[1].replace(',', '.')) * 100);
}

// ========== Checkout Preparation (clean properties for admin) ==========

// Build cleaned cart items + formatted summary for the order note
function buildCleanedCart(cart) {
  var groups = {};
  var ungrouped = [];

  cart.items.forEach(function (item) {
    var gid = item.properties && item.properties['_group_id'];
    if (!gid) {
      ungrouped.push(item);
      return;
    }
    if (!groups[gid]) groups[gid] = { parent: null, supplements: [] };
    if (item.properties['_group_type'] === 'parent') {
      groups[gid].parent = item;
    } else {
      groups[gid].supplements.push(item);
    }
  });

  var cleanedItems = [];
  var summaryLines = [];

  // Process grouped items
  Object.keys(groups).forEach(function (gid) {
    var group = groups[gid];
    if (!group.parent) {
      // Orphan supplements — add as ungrouped
      group.supplements.forEach(function (s) { ungrouped.push(s); });
      return;
    }

    var parent = group.parent;
    var suppNames = group.supplements.map(function (s) { return s.product_title; });

    // Clean parent properties
    var parentProps = {};
    // Préserve les choix d'options (Épaisseur, Sauce...) — propriétés non internes
    var parentOptSummary = [];
    if (parent.properties) {
      Object.keys(parent.properties).forEach(function (key) {
        if (key.charAt(0) !== '_' && key !== 'note') {
          parentProps[key] = parent.properties[key];
          parentOptSummary.push(key + ': ' + parent.properties[key]);
        }
      });
    }
    if (parent.properties && parent.properties['note']) {
      parentProps['Note'] = parent.properties['note'];
    }
    if (suppNames.length > 0) {
      parentProps['Supplements'] = suppNames.join(', ');
    }

    cleanedItems.push({
      id: parent.variant_id,
      quantity: parent.quantity,
      properties: parentProps
    });

    // Clean supplement properties
    group.supplements.forEach(function (supp) {
      var parentLabel = parent.product_title;
      if (parent.variant_title && parent.variant_title !== 'Default Title') {
        parentLabel += ' (' + parent.variant_title + ')';
      }
      cleanedItems.push({
        id: supp.variant_id,
        quantity: supp.quantity,
        properties: { 'Supplement pour': parentLabel }
      });
    });

    // Summary line
    var line = parent.quantity + 'x ' + parent.product_title;
    if (parent.variant_title && parent.variant_title !== 'Default Title') {
      line += ' (' + parent.variant_title + ')';
    }
    if (parentOptSummary.length > 0) {
      line += ' — ' + parentOptSummary.join(', ');
    }
    if (parent.properties && parent.properties['note']) {
      line += ' [' + parent.properties['note'] + ']';
    }
    summaryLines.push(line);
    suppNames.forEach(function (name) {
      summaryLines.push('   + ' + name);
    });
  });

  // Process ungrouped items
  ungrouped.forEach(function (item) {
    var props = {};
    var optSummary = [];
    if (item.properties) {
      Object.keys(item.properties).forEach(function (key) {
        if (key.charAt(0) !== '_') {
          props[key] = item.properties[key];
          if (key !== 'note') optSummary.push(key + ': ' + item.properties[key]);
        }
      });
    }
    cleanedItems.push({
      id: item.variant_id,
      quantity: item.quantity,
      properties: Object.keys(props).length > 0 ? props : {}
    });

    var line = item.quantity + 'x ' + item.product_title;
    if (item.variant_title && item.variant_title !== 'Default Title') {
      line += ' (' + item.variant_title + ')';
    }
    if (optSummary.length > 0) {
      line += ' — ' + optSummary.join(', ');
    }
    summaryLines.push(line);
  });

  return {
    items: cleanedItems,
    summary: summaryLines.length > 0 ? 'DETAIL COMMANDE:\n' + summaryLines.join('\n') : ''
  };
}

// Add items in batches of 20 (Shopify limit)
function addItemsInBatches(items) {
  var batchSize = 20;
  var batches = [];
  for (var i = 0; i < items.length; i += batchSize) {
    batches.push(items.slice(i, i + batchSize));
  }
  function addBatch(index) {
    if (index >= batches.length) return Promise.resolve();
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: batches[index] })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('add batch ' + index + ' failed');
      return r.json();
    })
    .then(function () { return addBatch(index + 1); });
  }
  return addBatch(0);
}

// Rollback: restore original cart if checkout preparation fails
function restoreCart(originalCart, triggerEl, originalText) {
  var items = originalCart.items.map(function (item) {
    return {
      id: item.variant_id,
      quantity: item.quantity,
      properties: item.properties || {}
    };
  });

  fetch('/cart/clear.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  })
  .then(function () { return addItemsInBatches(items); })
  .then(function () {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: originalCart.note || '', attributes: originalCart.attributes || {} })
    });
  })
  .then(function () {
    showToast('Erreur lors de la preparation. Votre panier a ete restaure.', 'error');
    resetCheckoutButton(triggerEl, originalText);
  })
  .catch(function () {
    showToast('Erreur critique. Veuillez rafraichir la page.', 'error');
    resetCheckoutButton(triggerEl, originalText);
  });
}

function resetCheckoutButton(el, text) {
  if (el) {
    el.textContent = text;
    el.disabled = false;
    el.style.pointerEvents = '';
  }
  window._checkoutInProgress = false;
}

// Main checkout preparation: clean properties + build summary note
window.prepareCheckout = function (triggerEl) {
  if (window._checkoutInProgress) return;
  window._checkoutInProgress = true;

  if (window.showTimeslotModal && !window._timeslotConfirmed) {
    window.showTimeslotModal(triggerEl);
    return;
  }
  window._timeslotConfirmed = false;

  var originalText = triggerEl ? triggerEl.textContent : '';
  if (triggerEl) {
    triggerEl.textContent = 'Preparation...';
    triggerEl.disabled = true;
    triggerEl.style.pointerEvents = 'none';
  }

  // Capture customer note from cart page textarea (if present)
  var customerNote = '';
  var noteEl = document.getElementById('CartNote');
  if (noteEl) customerNote = noteEl.value.trim();

  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (!cart.items || cart.items.length === 0) {
        window._checkoutInProgress = false;
        window.location.href = '/cart';
        return;
      }

      // Check if any items have group properties
      var hasGroups = cart.items.some(function (item) {
        return item.properties && item.properties['_group_id'];
      });

      if (!hasGroups) {
        // No groups: just update note if needed and redirect
        var note = customerNote || cart.note || '';
        if (note !== (cart.note || '')) {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: note })
          })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function () { window.location.href = '/checkout'; });
        } else {
          window.location.href = '/checkout';
        }
        return;
      }

      // Build cleaned cart
      var result = buildCleanedCart(cart);
      var cleanedItems = result.items;
      var summaryText = result.summary;

      // Compose final note
      var finalNote = customerNote || cart.note || '';
      if (summaryText) {
        if (finalNote) finalNote += '\n\n---\n\n';
        finalNote += summaryText;
      }

      var originalCart = cart;

      // Clear -> Re-add -> Update note -> Redirect
      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      })
      .then(function (r) {
        if (!r.ok) throw new Error('clear failed');
        return r.json();
      })
      .then(function () { return addItemsInBatches(cleanedItems); })
      .then(function () {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: finalNote, attributes: originalCart.attributes || {} })
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('note update failed');
        return r.json();
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        console.error('Checkout preparation failed:', err);
        restoreCart(originalCart, triggerEl, originalText);
      });
    })
    .catch(function (err) {
      console.error('Failed to fetch cart:', err);
      resetCheckoutButton(triggerEl, originalText);
    });
};

